import type { JSX } from 'solid-js';

interface ReadoutProps {
  v: string;
  l: string;
  /** Color token name (without `--` prefix) e.g. 'action', 'data', 'hostile'. */
  tone?: string;
  /** When true, render the value in the sans face instead of mono. */
  sans?: boolean;
}

export function Readout(props: ReadoutProps) {
  const valueStyle = (): JSX.CSSProperties => ({
    color: props.tone ? `var(--${props.tone})` : undefined,
    ...(props.sans ? { 'font-family': 'var(--sans)' } : {}),
  });
  return (
    <div class="readout">
      <div class="v" style={valueStyle()}>{props.v}</div>
      <div class="l">{props.l}</div>
    </div>
  );
}
